import { INote } from '../interfaces/noteInterface';
import { parseJwt } from './parseJwt';

/**
 * Check if the user is an sb-connect user based on their JWT token
 * @param token - JWT authentication token
 * @returns true if user has 'sb-connect' in their role, false otherwise
 */
export const isSbConnectUser = (token: string | null): boolean => {
  if (!token) return false;
  try {
    const payload: unknown = parseJwt(token);
    const lower = (v: unknown) =>
      typeof v === 'string' ? v.toLowerCase() : String(v ?? '').toLowerCase();

    const obj = (payload ?? {}) as Record<string, unknown>;
    const role = obj['role'] as string;

    if (typeof role === 'string') {
      return lower(role).includes('sb-connect');
    }
    return false;
  } catch {
    return false;
  }
};

export const haveDataInSections = (note?: INote) => {
  if (!note) return false;

  // Prefer dynamic detection: any key that includes 'Text' with non-empty content
  const keys = Object.keys(note).filter(k => k.toLowerCase().includes('text'));
  const recordNote = note as unknown as Record<string, unknown>;
  for (const key of keys) {
    const value = recordNote[key];
    if (Array.isArray(value)) {
      if (value.join(' ').trim().length > 0) return true;
    } else if (typeof value === 'string') {
      if (value.trim().length > 0) return true;
    }
  }
  return false;
};

export const isObjectEmpty = (obj: object): boolean =>
  Object.keys(obj).length === 0;

export const capitalizeWords = (str: string) => {
  if (!str) {
    return '';
  }
  return str
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export const formatTime = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
